import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import ApiClient from '../../utils/apiClient';

interface DeleteAccountDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function DeleteAccountDialog({ open, onClose }: DeleteAccountDialogProps) {
  const theme = useTheme();
  const [deletingAccount, setDeletingAccount] = React.useState(false);

  const handleDeleteAccount = async () => {
    setDeletingAccount(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return;
      }

      await ApiClient.delete('api/users/current');
      // Clear token and redirect to login
      localStorage.removeItem('token');
      window.location.href = '/login';
    } catch (error) {
      console.error('Error deleting account:', error);
      setDeletingAccount(false);
    }
  };

  const handleClose = () => {
    if (!deletingAccount) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title">
        Delete account
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description" sx={{ mb: 2 }}>
          This will delete your Energy Info UK account and all the data we have collected to provide this service to you. Your account with your energy provider will not be affected.
        </DialogContentText>
        <DialogContentText sx={{ mb: 2 }}>
          This process is <strong>PERMANENT</strong>. Once deleted your account cannot be recovered.
        </DialogContentText>
        <DialogContentText sx={{ mb: 2 }}>
          Are you sure you want to delete your account?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={handleClose} 
          disabled={deletingAccount}
          sx={{ 
            color: theme.palette.mode === 'dark' ? 'text.secondary' : 'text.primary',
            '&:hover': {
              backgroundColor: theme.palette.action.hover
            }
          }}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleDeleteAccount} 
          color="error" 
          variant="contained"
          disabled={deletingAccount}
        >
          {deletingAccount ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
